import DataTable from 'components/DataTable';
import ListWrapper from 'components/ListWrapper';
import Typography from 'components/Typography';
import {DataTableSchemaItem} from 'types';
import Pagination from 'components/Pagination';
import Button from 'components/Button';
import styles from './blogs.module.scss';
import useTemplate from './useTemplate';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'title',
    header: 'Title',
  },
  {dataKey: 'created_at', header: 'Created Date'},
  {
    dataKey: 'active',
    header: 'Published',
  },
  {dataKey: 'view', header: ''},
];

function TemplateList() {
  const {
    data,
    isLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    count,
    pageSize,
    setPageSize,
    onRowClick,
  } = useTemplate();

  return (
    <>
      <div className={styles.header}>
        <Typography variant="h2">Templates</Typography>
        <Button component="a" to="/website/templates/create" color="blue">
          Add Template
        </Button>
      </div>
      <ListWrapper>
        <DataTable
          onClick={onRowClick}
          schema={SCHEMA}
          data={data}
          loading={isLoading}
        />
        {totalPages > 1 && (
          <Pagination
            count={count}
            basePath="/templates"
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        )}
      </ListWrapper>
    </>
  );
}

export default TemplateList;
